import { ShieldCheck, DollarSign, ClipboardCheck, Star } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Licensed & Insured" },
  { icon: ClipboardCheck, label: "Free Estimates" },
  { icon: DollarSign, label: "Honest Pricing" },
  { icon: Star, label: "Veteran Values" },
];

export const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="relative z-10 bg-red-600">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-red-500/40">
          {ITEMS.map((it) => (
            <div
              key={it.label}
              className="flex items-center justify-center gap-3 py-5 md:py-6"
            >
              <it.icon className="h-5 w-5 text-white/90 shrink-0" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-wider text-white text-center">
                {it.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
